const host = window.location.host

let baseUrl = 'https://newtontutor.hk/api'
let roomUrl = 'https://newtontutor.hk/room'
// let baseUrl = 'https://121.idaguo.com/api'
if (host === '121.idaguo.com') {
  // baseUrl = 'https://121.idaguo.com/api'
  // roomUrl = 'https://121.idaguo.com/room'
  baseUrl = 'https://newtontutor.hk/api'
  roomUrl = 'https://newtontutor.hk/room'
} else if (host === 'newtontutor.hk' || host === 'www.newtontutor.hk') {
  baseUrl = 'https://newtontutor.hk/api'
  roomUrl = 'https://newtontutor.hk/room'
} else {
  baseUrl = 'https://newtontutor.hk/api'
  roomUrl = 'https://newtontutor.hk/room'
  // baseUrl = 'https://121.idaguo.com/api'
  // roomUrl = 'https://121.idaguo.com/room'
  // roomUrl = 'http://localhost:3001'
  // roomUrl = 'http://localhost:3001'
}
//  else if (host === '') {
//   baseUrl = ''
// }

export { roomUrl }

export default baseUrl
